module.exports = function hidden(md) {
  md.block.ruler.before('paragraph', 'hidden', function replace(state, startLine, endLine, silent) {
    if (silent) {
      return false;
    }

    const expectOpener = '[hidden]';
    const expectCloser = '[/hidden]';
    const start = state.bMarks[startLine] + state.tShift[startLine];
    let content = '';

    const oldParent = state.parentType;
    const oldLineMax = state.lineMax;

    let token;
    let closerLine;

    if (state.src.charAt(start) !== expectOpener[0]) {
      return false;
    }

    if (state.src.substr(start, expectOpener.length) !== expectOpener) {
      return false;
    }

    let closeFlag = false;

    for (closerLine = startLine + 1; closerLine <= endLine; closerLine++) {
      const closerStart = state.bMarks[closerLine] + state.tShift[closerLine];
      if (state.src.substr(closerStart, expectCloser.length) === expectCloser) {
        closeFlag = true;
        break;
      }

      content += state.getLines(closerLine, closerLine + 1, state.blkIndent, false) + '\n';
    }

    if (!closeFlag) {
      return false;
    }

    state.parentType = 'hidden';
    token = state.push('hidden_open', 'div', 1);
    token.markup = expectOpener;
    token.attrs = [['class', 'hidden']];
    token.block = true;

    const contentTokens = [];
    state.md.block.parse(content, state.md, state.env, contentTokens);
    contentTokens.forEach((t) => {
      state.tokens.push(t);
    });

    token = state.push('hidden_close', 'div', -1);
    token.markup = expectCloser;
    token.block = true;

    state.parentType = oldParent;
    state.lineMax = oldLineMax;
    state.line = closerLine + 1;

    return true;
  });
};
